/* BKS — logo réseau social brodé, affiché sur l'aperçu, collé DEVANT le pseudo (broderie arrière) et qui le suit
   (même place, même inclinaison, même étirement, même taille).
     · Insta  : le contour de l'appareil photo, couleur du fil de la broderie
     · Snap   : le logo officiel, carré jaune + fantôme blanc
     · TikTok : rond noir + la note couleur du fil de la broderie
   Marche sur tous les configurateurs : il repère l'élément du pseudo (#B_lat FUSION/DIRT, #B_pse VELTO/LA BKS V2,
   #B_ar scooter) et lit le choix « social » de l'état du configurateur. Se recolle à chaque fois que le configurateur
   réécrit le pseudo. */
(function(){
'use strict';
if(window.__bksBrodSocial)return; window.__bksBrodSocial=1;
var IDS=['B_lat','B_pse','B_ar'];
var SVG={
  insta:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><rect x="3" y="3" width="18" height="18" rx="5.2"/><circle cx="12" cy="12" r="4.3"/><circle cx="17.4" cy="6.6" r="1.3" fill="currentColor" stroke="none"/></svg>',
  snap:'<svg viewBox="0 0 24 24"><rect x="1" y="1" width="22" height="22" rx="6" fill="#FFFC00"/><path fill="#fff" stroke="#1a1a1a" stroke-width=".9" stroke-linejoin="round" d="M12 4.6c-2.6 0-4.3 2-4.3 4.6v1.6c-.5.1-1 .1-1.3.3-.3.2 0 .6.4.8.5.2.9.3.9.6-.4 1.2-1.6 2.4-3 2.8-.3.1-.3.5 0 .6.6.2 1.3.3 1.5.5.2.3.1.8.4.9.5.1 1.2-.2 2.1.1.8.3 1.6 1.4 3.3 1.4s2.5-1.1 3.3-1.4c.9-.3 1.6 0 2.1-.1.3-.1.2-.6.4-.9.2-.2.9-.3 1.5-.5.3-.1.3-.5 0-.6-1.4-.4-2.6-1.6-3-2.8 0-.3.4-.4.9-.6.4-.2.7-.6.4-.8-.3-.2-.8-.2-1.3-.3V9.2c0-2.6-1.7-4.6-4.3-4.6z"/></svg>',
  tiktok:'<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="11.5" fill="#000"/><path fill="currentColor" d="M13.3 5.6h2.3c.2 1.5 1.3 2.6 2.8 2.8v2.3c-1.1 0-2-.3-2.8-.9v4.9a3.9 3.9 0 1 1-3.9-3.9h.4v2.3h-.4a1.6 1.6 0 1 0 1.6 1.6V5.6z"/></svg>'
};
function social(){
  try{
    var T=window.__BKS_CFG2_TEST; if(T&&T.etat){ var e=typeof T.etat==='function'?T.etat():T.etat; if(e&&e.social)return e.social; }
    if(typeof window.__BKS_SOCIAL==='function')return window.__BKS_SOCIAL();
  }catch(er){}
  return 'aucun';
}
function coller(el){
  var s=social(), deja=el.querySelector('.bks-soc'), k=deja&&deja.getAttribute('data-soc');
  if(!SVG[s]||!el.textContent.trim()){ if(deja)deja.remove(); return; }
  /* le pseudo est étiré en hauteur (scaleY) : le logo, lui, doit rester rond / carré et faire la hauteur des lettres.
     On le dessine donc plus large d'autant : une fois étiré avec le texte, il redevient carré. */
  var m=/scaleY\(([\d.]+)\)/.exec(el.style.transform||''), sy=m?parseFloat(m[1])||1:1;
  var cote=0.82;   /* hauteur du logo ≈ hauteur des majuscules (en em, avant étirement) */
  var css='display:inline-block;width:'+(cote*sy).toFixed(3)+'em;height:'+cote+'em;margin-right:'+(0.22*sy).toFixed(3)+'em;vertical-align:-.04em;line-height:0;filter:drop-shadow(0 1px 1.5px rgba(0,0,0,.55))';
  if(deja&&k===s&&el.firstChild===deja){ if(deja.getAttribute('data-css')!==css){ deja.setAttribute('data-css',css); deja.style.cssText=css; } return; }   // déjà en place (pas de boucle)
  if(deja)deja.remove();
  var i=document.createElement('span'); i.className='bks-soc'; i.setAttribute('data-soc',s); i.setAttribute('aria-hidden','true');
  i.style.cssText=css; i.setAttribute('data-css',css);
  i.innerHTML=SVG[s];
  var sv=i.firstChild; sv.setAttribute('preserveAspectRatio','none'); sv.setAttribute('shape-rendering','geometricPrecision');
  sv.style.width='100%'; sv.style.height='100%'; sv.style.display='block';
  el.insertBefore(i,el.firstChild);
}
function brancher(){
  IDS.forEach(function(id){
    var el=document.getElementById(id); if(!el||el.__bksSoc)return; el.__bksSoc=1;
    new MutationObserver(function(){ coller(el); }).observe(el,{childList:true,characterData:true,subtree:true,attributes:true,attributeFilter:['style'],attributeOldValue:false});
    coller(el);
  });
}
/* le choix du logo se fait par un clic qui redessine l'aperçu ; filet de sécurité si un configurateur ne redessine pas */
document.addEventListener('click',function(){ setTimeout(function(){ IDS.forEach(function(id){ var el=document.getElementById(id); if(el)coller(el); }); },60); },true);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',brancher); else brancher();
setTimeout(brancher,1500);
})();
